import React, { useCallback, useState } from 'react';
import { Flex } from 'rebass/styled-components';
import { ContactsLinkedInSync } from 'pages/contactsLinkedInSync';
import PropTypes from 'prop-types';
import { Button } from '@getro/rombo';
import { Redirect } from 'react-router-dom';

import { NetworkAdminOnboardingLinkedinSyncActive } from '../components/networkAdminOnboardingLinkedinSyncActive';

export const LinkedIn = ({ handleNextStep, user, activeNetwork }) => {
  const [syncStatus, setSyncStatus] = useState(
    user?.linkedinSync?.syncStatus !== 'active' ? null : user?.linkedinSync?.syncStatus,
  );

  const handleSyncStatusChange = useCallback(() => {
    setSyncStatus('done');
  }, []);

  if (syncStatus === 'active') {
    return <Redirect to={`/networks/${activeNetwork.slug}/welcome/onboarding/team`} />;
  }

  return (
    <Flex sx={{ flexDirection: 'column', width: '432px', mx: 'auto', mt: '100px', gap: '16px' }}>
      {setSyncStatus && syncStatus !== 'done' && (
        <ContactsLinkedInSync isNetworkAdminOnboarding onSyncStatusChange={handleSyncStatusChange} />
      )}
      <Flex sx={{ flexDirection: 'column', width: '100%', gap: '24px' }}>
        {syncStatus && (
          <NetworkAdminOnboardingLinkedinSyncActive handleNextStep={handleNextStep} activeNetwork={activeNetwork} />
        )}
        {!syncStatus && (
          <Button
            size="small"
            variant="secondary"
            sx={{ width: '100%', justifyContent: 'center', border: 'none', p: 0, fontSize: '14px' }}
            onClick={() => handleNextStep('linkedin-sync')}
          >
            Skip
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

LinkedIn.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  activeNetwork: PropTypes.object.isRequired,
};
